import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';
import {
  BackResponse,
  BackResponseFailure,
  QuotationEnrichedDto,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}files/${COMMON_QUERY_PARAMS.FILE_ID}/quotation/pendingCustomerValidation`;

async function getPendingCustomerValidationByFileId({
  fileId,
}: {
  fileId: string;
}): Promise<BackResponse<QuotationEnrichedDto> | BackResponseFailure> {
  const functionName = 'getPendingCustomerValidationByFileId';

  if (!fileId) {
    throw new RequiredPayloadFieldIsNotProvided('fileId', functionName);
  }

  const url = buildUrl(ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId));

  try {
    return await apiCall(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getPendingCustomerValidationByFileId;
